import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { Spinner } from 'flowbite-react';
import Image from 'next/image';

import ACTION_TYPE from 'store/action-type';

import PaginationComponent from '../common/PaginationComponent';
import Container from '../common/Container';

import ModalSuscribeNotifications from './ModalSubscribeNotifications';
import ModalForwadFriends from './ModalForwadFriends';
import FindYourDreamJobIndia from './FindYourDreamJobIndia';
import JobFilter from './JobFilter';

export default function FindYourDreamJob({ country, section }) {
  const [paginationOptions, setPaginationOptions] = useState({
    totalResults: 0,
    page: 1,
    limit: 15,
  });
  const { page, limit } = paginationOptions;
  const [jobs, setJobs] = useState([]);
  const [title, setTitle] = useState('');
  const [work, setWork] = useState('');
  const [city, setCity] = useState('');
  const [sortDate, setSortDate] = useState('NEWEST');
  const [filterJobs, setFilterJobs] = useState([]);
  const [modalFowardFriend, setModalFowardFriend] = useState(false);
  const [modalSuscribeNotifications, setModalSuscribeNotifications] =
    useState(false);
  const { push } = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    if (filterJobs && filterJobs?.length > 0) {
      const temp = filterJobs.slice(limit * (page - 1), limit * page);
      setPaginationOptions(prev => {
        return { ...prev, totalResults: filterJobs?.length };
      });
      setJobs(temp);
    } else {
      // Logic for default job display
      const SortByDate = (data, type) => {
        if (type === 'OLDEST') {
          data?.sort(
            (a, b) =>
              new Date(a?.issuedate?._text) - new Date(b?.issuedate?._text)
          );
          return data;
        } else {
          data?.sort(
            (a, b) =>
              new Date(b?.issuedate?._text) - new Date(a?.issuedate?._text)
          );
          return data;
        }
      };
      let data = SortByDate(section, sortDate);
      const temp = data?.slice(limit * (page - 1), limit * page);
      setPaginationOptions(prev => {
        return { ...prev, totalResults: section?.length };
      });
      setJobs(temp);
    }
  }, [section, filterJobs, sortDate, limit, page]);

  if (country === null) {
    return (
      <div className="text-center my-10">
        <Spinner size={'xl'} aria-label="Center-aligned spinner example" />
      </div>
    );
  }

  return (
    <div id="fine-your-dream-job">
      <div className="py-0">
        <section className="md:py-[55px] py-[30px]">
          <div className="container mx-auto px-4">
            <div className="md:w-[60%] w-[100%]">
              <h5 className="font-[400] md:text-[20px] text-[16px] leading-tight text-[#353535]">
                FIND YOUR DREAM JOB
                <span className="inline-block ml-4 bg-[#353535] w-[50px] h-[2px] align-middle"></span>
              </h5>
              <h2 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight my-4">
                Join Our Team
              </h2>
              <p className="font-[400] text-[16px] leading-tight text-[#353535]">
                VLink isn’t just a company. It’s a way of living and working
                where creativity and problem solving come together. Building
                something new and different isn’t the challenge here, it’s the
                reward.
              </p>
            </div>
          </div>
        </section>
      </div>

      {country ? (
        <Container>
          <JobFilter // Use the new component here
            section={section}
            setFilterJobs={setFilterJobs} // Ensure this line is correct
            setPaginationOptions={setPaginationOptions}
            sortDate={sortDate}
            setSortDate={setSortDate}
            title={title}
            setTitle={setTitle}
            work={work}
            setWork={setWork}
            city={city}
            setCity={setCity}
          />
          <div className="py-16">
            <div className="grid grid-cols-12 gap-0">
              <div className="col-span-12 mb-8">
                <h2 className="font-bold text-black text-4xl text-center">
                  {filterJobs?.length > 0
                    ? filterJobs?.length
                    : section?.length}
                  &nbsp;Jobs availables
                </h2>
              </div>
            </div>
            {jobs &&
              jobs?.length > 0 &&
              jobs?.map(item => {
                return (
                  <div
                    key={item?.id}
                    className="border border-[#B5B5B5] bg-[#ffffff] rounded-[10px] py-8 px-6 mb-8 cursor-pointer"
                    onClick={async () => {
                      dispatch({
                        type: ACTION_TYPE.JOB_DETAIL,
                        payload: {
                          jobId: item,
                        },
                      });
                      push({
                        pathname: '/resources/career/job-detail',
                        query: `job=${item?.title?._cdata.replace(
                          /\s/g,
                          '-'
                        )}-${item?.jobdiva_no?._text}`,
                      });
                    }}
                  >
                    <div className="grid grid-cols-12 gap-0">
                      <div className="lg:col-span-8 col-span-12 lg:mb-0 mb-4">
                        <h6 className=" text-[24px] font-[600] text-[#1D1D1D] mb-3">
                          {item?.title?._cdata} – J{item?.jobdiva_no?._text}
                        </h6>
                        <p className="inline-block text-[#0C2139] text-[16px]  font-[600] border-l-[1px]  px-3 leading-[21px]">
                          Required Experience:
                          <span className=" text-[16px] font-[400] text-[#353535]">
                            {item?.experience_level?._text}
                          </span>
                        </p>
                        <ul className="mt-3">
                          <li className="inline-block text-[#0C2139] text-[16px]  font-[600] px-2 leading-[21px]">
                            <span>
                              {item?.city?._text +
                                ' ,' +
                                item?.state?._text +
                                ' ,' +
                                item?.countryid?._text}
                            </span>
                          </li>
                          <li className="inline-block text-[#0C2139] text-[16px]  font-[600] border-l-[1px] border-l-[#0C2139] px-3 leading-[21px]">
                            Date of Posting :&nbsp;
                            {DateTime.fromJSDate(
                              item?.issuedate?._text &&
                                new Date(item?.issuedate?._text)
                            ).toFormat('MM-dd-yyyy')}
                          </li>
                          <li className="inline-block text-[#0C2139] text-[16px]  font-[400] py-1 px-4 border border-[#62207E] rounded-[40px] ">
                            <span>{item?.positiontype?._text}</span>
                          </li>
                        </ul>
                      </div>
                      <div className="lg:col-span-4 col-span-12 lg:text-right text-left">
                        <button
                          onClick={event => {
                            event.stopPropagation();
                            setModalFowardFriend(true);
                          }}
                          className="border border-[#B5B5B5]  text-[12px] font-[600] text-[#1D1D1D] inline-flex items-center justify-center px-4 py-2 mr-2 mb-2"
                        >
                          Forward to a Friend
                          <Image
                            src="/img/Icon.svg"
                            alt="icon"
                            class="ml-2"
                            width={20}
                            height={20}
                          />
                        </button>
                        <button
                          onClick={event => {
                            event.stopPropagation();
                            setModalSuscribeNotifications(true);
                          }}
                          className="bg-[#0050D5]  text-[12px] font-[600] text-[#ffffff] rounded-[4px] px-4 py-2"
                        >
                          APPLY NOW
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            {jobs && jobs.length > 0 && (
              <PaginationComponent
                paginationOptions={paginationOptions}
                onPagination={setPaginationOptions}
              />
            )}
          </div>
        </Container>
      ) : (
        <FindYourDreamJobIndia />
      )}

      {modalFowardFriend ? (
        <ModalForwadFriends
          isOpen={modalFowardFriend}
          setIsOpen={setModalFowardFriend}
        />
      ) : null}
      {modalSuscribeNotifications ? (
        <ModalSuscribeNotifications
          isOpen={modalSuscribeNotifications}
          isApplyJob={true}
          setIsOpen={setModalSuscribeNotifications}
        />
      ) : null}
    </div>
  );
}
